import React from "react";
import EditorHeaderForTemplate from "../../components/Editor/EditorHeaderForTemplate";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorMainHeader = () => {
  const ctx = useEditorMainPageContext();

  return (
    <EditorHeaderForTemplate
      getEditSaveAssets={ctx.getEditSaveAssets}
      setIsOneTimeAsset={ctx.setIsOneTimeAsset}
      isOneTimeAsset={ctx.isOneTimeAsset}
      loadingModules={ctx.loadingModules}
      setBannerValidationCheck={ctx.setBannerValidationCheck}
      allMustUseDataEmpty={ctx.allMustUseDataEmpty}
      removeSymbol={ctx.removeSymbol}
      setRemoveSymbol={ctx.setRemoveSymbol}
      bannerValidationCheck={ctx.bannerValidationCheck}
      saveBannerValidationCheckDetails={ctx.saveBannerValidationCheckDetails}
      undoStack={ctx.undoStack}
      redoStack={ctx.redoStack}
      setUndoVersion={ctx.setUndoVersion}
      undoVersion={ctx.undoVersion}
      rhsUpdateTrigger={ctx.rhsUpdateTrigger}
      moduleSymbol={ctx.moduleSymbol}
      setmoduleSymbol={ctx.setmoduleSymbol}
      mustUseData={ctx.mustUseData}
      setEditModuleClicked={ctx.setEditModuleClicked}
      handleChangeSizeRefereshModulesData={
        ctx.handleChangeSizeRefereshModulesData
      }
      setMLRstatus={ctx.setMLRstatus}
      setDamsId={ctx.setDamsId}
      handleZoomIn={ctx.handleZoomIn}
      handleZoomOut={ctx.handleZoomOut}
      setEditComponent={ctx.setEditComponent}
      layerCompData={ctx.layerCompData}
      canvasDimension={ctx.canvasDimension}
      bgColorCanvas={ctx.canvasDimension?.backgroundColor}
      animationObject={ctx.animationObject}
      animationObjRef={ctx.animationObjRef}
      tempLayer={ctx.tempLayer}
      selectedComponent={ctx.selectedComponent}
      popUpOptions={ctx.popUpOptions}
      setLayerCompData={ctx.setLayerCompData}
      setSelectedComponent={ctx.setSelectedComponent}
      setCount={ctx.setCount}
      setAnimationObject={ctx.setAnimationObject}
      renderAppliedFonts={ctx.renderAppliedFonts}
      toggleAnimatedBanner={ctx.toggleAnimatedBanner}
      addedActionsList={ctx.addedActionsList}
      refreshed={ctx.refreshed}
      layerLengthAtRefresh={ctx.layerLengthAtRefresh}
      setundoFlag={ctx.setundoFlag}
      addedCanvasActionsList={ctx.addedCanvasActionsList}
      handleCanvasUndo={ctx.handleCanvasUndo}
      listForReDo={ctx.listForReDo}
      handleRedo={ctx.handleRedo}
      undoCount={ctx.undoCount}
      playPause={ctx.playPause}
      setPlayPause={ctx.setPlayPause}
      bannerChanged={ctx.bannerChanged}
      refBannerChanged={ctx.refBannerChanged}
      setBannerChanged={ctx.setBannerChanged}
      setRefreshed={ctx.setRefreshed}
      showBannertype={ctx.showBannertype}
      showBannerName={ctx.showBannerName}
      setShowBannerName={ctx.setShowBannerName}
      showAssettype={ctx.showAssettype}
      linkedModulesType={ctx.linkedModulesType}
      selectedSizeOptions={ctx.selectedSizeOptions}
      selectedBannerSize={ctx.selectedBannerSize}
      setMultiSelectedComponent={ctx.setMultiSelectedComponent}
      setBgColorCanvas={ctx.setBgColorCanvas}
      setCanvasDimension={ctx.setCanvasDimension}
      setLoadingModules={ctx.setLoadingModules}
      setchangeInEditor={ctx.setchangeInEditor}
      changeInEditor={ctx.changeInEditor}
      showPreview={ctx.showPreview}
      setPreView={ctx.setPreView}
      previewURl={ctx.previewURl}
      setpreviewURl={ctx.setpreviewURl}
      previewRedirectHome={ctx.previewRedirectHome}
      setPreviewRedirectHome={ctx.setPreviewRedirectHome}
      claimReferencesFootnotes={ctx.claimReferencesFootnotes}
      setClaimReferencesFoonotes={ctx.setClaimReferencesFoonotes}
    />
  );
};
